import React from "react";
import * as Mui from "@mui/material";
import { makeStyles } from "tss-react/mui";
import * as Icons from "react-feather";
import { styles } from "./subsection-header-style";

interface Props {
	label: string;
	isOverdue?: boolean;
}

const useStyles = makeStyles()(styles);

export const SubsectionHeader: React.FC<Props> = ({ label, isOverdue = false }) => {
	const { classes } = useStyles();

	return (
		<div className={classes.subheader}>
			{isOverdue && (
				<Icons.Clock className={classes.overdueIcon} size={20} />
			)}
			<Mui.Typography
				className={isOverdue ? classes.overdueText : classes.normalText}
			>
				{label}
			</Mui.Typography>
		</div>
	);
};
